// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"PreviewTableHeader_visuallyHidden__3Bohf","headerCell":"PreviewTableHeader_headerCell__3oJHo"};